import { Group, Mesh, MeshBasicMaterial, Object3D, PlaneGeometry } from "three";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";
import { Font, FontLoader } from "three/examples/jsm/loaders/FontLoader";

let fontPromise: Promise<Font> = null;
const
    cache = new Map(),
    planeGeometry = new PlaneGeometry(1, 1),
    textMaterial = new MeshBasicMaterial({ color: 0x000000, transparent: true }),
    textPlaneMaterial = new MeshBasicMaterial({ color: 0xFFFFFF, transparent: true }),
    loader = new FontLoader();

const createTechDrawingLabel = async (text: string, size: number, x: number, y: number, scene: Object3D) => {
    if(fontPromise == null) {
        fontPromise = new Promise(resolve => {
            loader.load('fonts/gentilis_bold.typeface.json', function (font) {
                resolve(font);
            });
        });
    }

    // TODO: this await will never complete in the transitional app test page
    // and log a 404, which was easy for me to overlook. Maybe we just need
    // to actually fail on a loader error above and log the exception.
    const
        font = await fontPromise,
        cacheKey = `${text}|${size}`

    let textGeo: TextGeometry;
    if(cache.has(cacheKey)) {
        textGeo = cache.get(cacheKey);
    }
    else {
        textGeo = new TextGeometry(text, {
            font: font,
            size: size,
            curveSegments: 1,
        });
        textGeo.computeBoundingBox();
        cache.set(cacheKey, textGeo);
    }
    let
        textWidth = textGeo.boundingBox.max.x - textGeo.boundingBox.min.x,
        textHeight = textGeo.boundingBox.max.y - textGeo.boundingBox.min.y;

    const group = new Group();
    group.position.set(x, y + (textHeight + 0.5)/2, 100);
    group.userData.isTechLabel = true;
    group.userData.techLabelText = text;

    const mesh = new Mesh(textGeo, textMaterial);
    mesh.userData.isTechLabelMesh = true;
    mesh.position.set(-textWidth / 2, - textHeight/2, 1);

    const plane = new Mesh(planeGeometry, textPlaneMaterial);
    plane.userData.isTechLabelMesh = true;
    plane.scale.set(textWidth + 0.5, textHeight + 0.5, 1);
    
    group.add(mesh);
    group.add(plane);
    scene.add(group); 
}

export default createTechDrawingLabel;
